<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info')}}</h4>
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.orgLegalName"
            v-model="GrantForm.revisionModel.technical.orgLegalName"
            :error="getError('technical.orgLegalName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_org_legal_name')"
            :label="$t('medium_grant.technical__2_org_legal_name')"
            :placeholder="$t('medium_grant.technical__2_org_legal_name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.orgShortName"
            v-model="GrantForm.revisionModel.technical.orgShortName"
            :label="$t('medium_grant.technical__2_org_short_name')"
            :placeholder="$t('medium_grant.technical__2_org_short_name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.website"
            v-model="GrantForm.revisionModel.technical.website"
            :label="$t('medium_grant.technical__2_website')"
            :placeholder="$t('medium_grant.technical__2_website')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.mailing"
            v-model="GrantForm.revisionModel.technical.mailing"
            :error="getError('technical.mailing')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_mailing')"
            :label="$t('medium_grant.technical__2_mailing')"
            :placeholder="$t('medium_grant.technical__2_mailing')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.physical"
            v-model="GrantForm.revisionModel.technical.physical"
            :error="getError('technical.physical')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__2_physical')"
            :label="$t('medium_grant.technical__2_physical')"
            :placeholder="$t('medium_grant.technical__2_physical')"
          >
          </textarea>
        </div>

        <h3 class="card-title">{{$t('medium_grant.technical__2_project_lead_contact_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_project_lead_contact_sub')}}</p>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.leadName"
            v-model="GrantForm.revisionModel.technical.leadName"
            :error="getError('technical.leadName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.leadEmail"
            v-model="GrantForm.revisionModel.technical.leadEmail"
            :error="getError('technical.leadEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.leadPhone"
            v-model="GrantForm.revisionModel.technical.leadPhone"
            :error="getError('technical.leadPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
          >
          </textarea>
        </div>
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_chief_title')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_chief_sub')}}</p>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.chiefName"
            v-model="GrantForm.revisionModel.technical.chiefName"
            :error="getError('technical.chiefName')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__name')"
            :label="$t('medium_grant.general__name')"
            :placeholder="$t('medium_grant.general__name')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.chiefEmail"
            v-model="GrantForm.revisionModel.technical.chiefEmail"
            :error="getError('technical.chiefEmail')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__email')"
            :label="$t('medium_grant.general__email')"
            :placeholder="$t('medium_grant.general__email')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.chiefPhone"
            v-model="GrantForm.revisionModel.technical.chiefPhone"
            :error="getError('technical.chiefPhone')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.general__telephone')"
            :label="$t('medium_grant.general__telephone')"
            :placeholder="$t('medium_grant.general__telephone')"
          >
          </textarea>
        </div>
      </div>
      <div class="col-lg-1"></div>
      <div class="col-lg-7">
        <h3 class="card-title">{{$t('medium_grant.technical__2_org_type_aplicant')}}</h3>
        <p class="small">{{$t('medium_grant.technical__2_org_type_aplicant_sub')}}</p>
        <div>
          <label v-if="getError('organisationType')" class="text-danger">{{getError('organisationType')}}</label>
          <radio name="organisationType"
                 inline
                 value="government_agency"
                 v-validate="'required'"
                 :data-vv-as="$t('general.field')"
                 v-model="GrantForm.revisionModel.technical.organisationType"
          >
            {{$t('page_user.profile__government_agency')}}
          </radio>
          <radio name="organisationType" inline value="protected_conserved_area" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__protected_conserved_area')}}
          </radio>
          <radio name="organisationType" inline value="civil_society_ngo" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__civil_society_ngo')}}
          </radio>
          <radio name="organisationType" inline value="local_community_cbo" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__local_community_cbo')}}
          </radio>
          <radio name="organisationType" inline value="small_medium_enterprise_sme" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__small_medium_enterprise_sme')}}
          </radio>
          <radio name="organisationType" inline value="european_member" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__european_member')}}
          </radio>
          <radio name="organisationType" inline value="oecd_member" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__oecd')}}
          </radio>
          <radio name="organisationType" inline value="regional_org" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__regional_org')}}
          </radio>
          <radio name="organisationType" inline value="international_org" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__international_org')}}
          </radio>
          <radio name="organisationType" inline value="other" v-model="GrantForm.revisionModel.technical.organisationType">
            {{$t('page_user.profile__other')}}
          </radio>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('page_user.profile__other_specify')"
              v-model="GrantForm.revisionModel.technical.organisationTypeOther"
            >
            </textarea>
        </base-input>
        <p class="mt-2 mb-4">{{$t('page_user.profile__organisation_type_note')}}</p>

        <label>{{$t('medium_grant.technical__2_org_history_mission')}}</label>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.revisionModel.technical.orgHistoryMission"
            >
            </textarea>
        </base-input>
        <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.revisionOrgFullfilmentEligibility" :is-editable="GrantForm.isRevisionEditable" :file-data="GrantForm.files.technical.revisionOrgFullfilmentEligibility" :size-limit="GrantForm.fileSizeLimit" section="technical.revisionOrgFullfilmentEligibility"></upload-file>
      </div>
    </div>
    <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co')}}</h4>
    <div class="row">
      <div class="col-lg-4">
        <label class="col-form-label">{{$t('medium_grant.technical__2_does_include_co')}}</label>
        <div>
          <div class="form-check form-check-radio form-check-inline">
            <radio name="technical.doesIncludeCo"
                   inline value="true"
                   v-validate="'required'"
                   :data-vv-as="$t('general.field')"
                   v-model="GrantForm.revisionModel.technical.doesIncludeCo"
            >
              {{$t('medium_grant.general__yes')}}
            </radio>
            <radio name="technical.doesIncludeCo" inline value="false" v-model="GrantForm.revisionModel.technical.doesIncludeCo">
              {{$t('medium_grant.general__no')}}
            </radio>
          </div>
          <div>
            <label v-if="getError('technical.doesIncludeCo')" class="text-danger">{{getError('technical.doesIncludeCo')}}</label>
          </div>
        </div>

        <label class="mt-2 mb-4">{{$t('medium_grant.technical__2_does_include_co_if_yes')}}</label>

        <h4 class="card-title">{{$t('medium_grant.technical__2_organisational_info_co1')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coApplicantOrgName"
            v-model="GrantForm.revisionModel.technical.coApplicantOrgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coShortDescOrg"
            v-model="GrantForm.revisionModel.technical.coShortDescOrg"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.roleInProject"
            v-model="GrantForm.revisionModel.technical.roleInProject"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
          >
          </textarea>
        </div>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.amountOfTotalBudget"
            v-model="GrantForm.revisionModel.technical.amountOfTotalBudget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
          >
          </textarea>
        </div>

        <div v-if="orgCoApplicants" v-for="(orgCoApplicant, index) in orgCoApplicants" :key="index">
          <h4 class="card-title">
            {{$t('medium_grant.technical__2_organisational_info_co_only') + ' ' + (index+2)}}

            <base-button class="ml-2" @click="orgCoApplicants.splice(index, 1)" size="sm" icon type="danger">
              <i class="fas fa-times"></i>
            </base-button>
          </h4>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coApplicantOrgName"
            v-model="orgCoApplicant.orgName"
            :label="$t('medium_grant.technical__2_org_name_co_app')"
            :placeholder="$t('medium_grant.technical__2_org_name_co_app')"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.coShortDescOrg"
            v-model="orgCoApplicant.shortDesc"
            :label="$t('medium_grant.technical__2_short_desc_of_org')"
            :placeholder="$t('medium_grant.technical__2_short_desc_of_org')"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.roleInProject"
            v-model="orgCoApplicant.role"
            :label="$t('medium_grant.technical__2_role_in_project')"
            :placeholder="$t('medium_grant.technical__2_role_in_project')"
          >
          </textarea>
          </div>
          <div class="form-group">
          <textarea
            class="form-control"
            name="technical.amountOfTotalBudget"
            v-model="orgCoApplicant.budget"
            :label="$t('medium_grant.technical__2_amount_of_total_budget')"
            :placeholder="$t('medium_grant.technical__2_amount_of_total_budget')"
          >
          </textarea>
          </div>
        </div>
        <base-button @click="addOrgCoApplicant" type="primary" class="btn-simple" size="sm">
          + {{$t('medium_grant.technical__2_organisational_info_co_add')}}
        </base-button>

      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";
  import {BaseCheckbox, BaseRadio} from 'src/components/index';

  export default {
    data() {
      return {
        GrantForm,
        orgCoApplicants: []
      }
    },
    components: {
      BaseCheckbox,
      BaseRadio
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      addOrgCoApplicant() {
        this.orgCoApplicants.push({
          orgName: '',
          shortDesc: '',
          role: '',
          budget: ''
        })
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    },
    mounted() {
      if (GrantForm.revisionModel.technical.orgCoApplicants) {
        this.orgCoApplicants = GrantForm.revisionModel.technical.orgCoApplicants;
      }
    },
    watch: {
      orgCoApplicants(value) {
        GrantForm.revisionModel.technical.orgCoApplicants = value;
      }
    },
  }
</script>
